import { useMutation, useQuery } from "react-query";
import { planBTAPI } from "../../services/planAPI";
import { AxiosError } from "axios";
import { PolePatch } from "../../types/planBT.types";
import { CallbackFunction } from "../../../../common/types/callback.types";

export interface SinglePoleCoreConfig {
  PlanId?: string;
  PoleId?: string;
}

export default function useSinglePoleCore({
  PlanId,
  PoleId,
}: SinglePoleCoreConfig) {
  const getSinglePoleQuery = useQuery({
    queryKey: ["pole", PlanId, PoleId],
    queryFn: () =>
      planBTAPI.getSinglePoleFromPlanBT(PlanId || "", PoleId || ""),
    enabled: PlanId && PoleId ? true : false,
  });

  const updateSinglePoleQuery = useMutation({
    mutationKey: ["pole", PlanId, PoleId],
    mutationFn: ({
      pole,
      callback,
    }: {
      pole: PolePatch;
      callback?: CallbackFunction;
    }) =>
      planBTAPI
        .updateSinglePoleFromPlanBT(PlanId || "", PoleId || "", pole)
        .then((result) => {
          callback && callback({ result });
        })
        .catch((error: AxiosError) => {
          callback && callback({ error });
          return Promise.reject(error);
        }),
    onSettled: () => {
      getSinglePoleQuery.refetch();
    },
  });

  return {
    singlePoleQuery: {
      ...getSinglePoleQuery,
      error: getSinglePoleQuery.error as AxiosError,
    },
    updateSinglePoleQuery: {
      ...updateSinglePoleQuery,
      error: updateSinglePoleQuery.error as AxiosError,
    },
    currentPlanId: PlanId,
  };
}
